import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { AddressInputWUT } from '../../../ui/address-input';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
import { useAddressAutofill } from '../../multiline-address/multiline-address/address-autofill-context';
export const MlaStreetNameWUT = _ref => {
  let {
    autocomplete,
    ...rest
  } = _ref;
  const fieldType = FIELD_TYPES.MLA_STREET_NAME;
  const {
    autocompleteEnabled
  } = useAddressAutofill();
  const label = useAddressLabel('streetName');
  return autocomplete || autocompleteEnabled ? /*#__PURE__*/React.createElement(AddressInputWUT, _extends({}, rest, {
    fieldType: fieldType,
    label: label
  })) : /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, rest, {
    fieldType: fieldType,
    label: label
  }));
};
//# sourceMappingURL=mla-street-name-wut.js.map